import moment from "moment";
import { endpoint } from "views/pages/manage/common/constant";
import { dropdownMapping } from "../../constant/batch-search";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const DEFAULT_FORM_FIELDS = {
  id: "",
  date: new moment().format("YYYY-MM-DD"),
  description: "",
};

const mobileRegex = /^(?!(\d)\1{9})[5-9]\d{9}$/;

export const isValidMobile = (num) => {
  const trimmed = num?.trim();
  return mobileRegex.test(trimmed);
};

export const GenderOptions = [
  {
    label: "Male",
    value: "M",
  },
  {
    label: "Female",
    value: "F",
  },
  {
    label: "Others",
    value: "O",
  },
];

export const BloodGroupOptions = [
  {
    label: "A+",
    value: "A+",
  },
  {
    label: "A-",
    value: "A-",
  },
  {
    label: "B+",
    value: "B+",
  },
  {
    label: "B-",
    value: "B-",
  },
  {
    label: "O+",
    value: "O+",
  },
  {
    label: "O-",
    value: "O-",
  },
  {
    label: "AB+",
    value: "AB+",
  },
  {
    label: "AB-",
    value: "AB-",
  },
];

export const fetchCategCityStateCountryMasterDropdowns = async () => {
  const p = await Promise.all([
    dropdownMapping(endpoint.studentCategories, "studentCategories"),
    dropdownMapping(`${endpoint.city.getAll}`, "cityDispValue"),
    dropdownMapping(`${endpoint.state.getAll}`, "stateDispValue"),
    dropdownMapping(`${endpoint.country.getAll}`, "countryDispValue"),
  ]);

  return {
    category: p[0],
    city: p[1],
    state: p[2],
    country: p[3],
  };
};

export const updateStudentDetails = async ({ psid, payload }) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.studentDetails.updateStudentDetails}/${psid}`,
    payload,
    "put"
  );

  return response;
};

export const updateStudentContactDetails = async ({ psid, payload }) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.studentDetails.updateStudentContactDetails}/${psid}`,
    payload,
    "put"
  );

  return response;
};

export const updateContactDetails = async ({ psid, payload1, payload2 }) => {
  const p = await Promise.allSettled([
    updateStudentDetails({ psid, payload: payload1 }),
    updateStudentContactDetails({ psid, payload: payload2 }),
  ]);

  return { api1Response: p[0]?.value || {}, api2Response: p[1]?.value || {} };
};

export const getEditLogs = async ({ psid, category, page, limit }) => {
  const response = await fetchAllPromisedData(
    `${endpoint.studentDetails.getStudentDetailAudit}/${psid}?category=${category}&page=${page}&size=${limit}`
  );

  return response;
};

export const validatePincode = async (val, masterDropdowns = {}) => {
  try {
    const data = await fetchAllPromisedData(
      `${endpoint?.pincode?.getPinCodeDetails}/${val}`,
      true
    );
    if (data?.code == 200) {
      const pincodeCodeDetails = data?.data;

      const { city, state, country } = masterDropdowns;

      const cityText = city.find(
        (city) => city.value === pincodeCodeDetails?.cityId
      )?.label;

      const stateText = state.find(
        (state) => state.value === pincodeCodeDetails?.stateId
      )?.label;

      const countryText = country.find(
        (country) => country.value === pincodeCodeDetails?.countryId
      )?.label;

      return { cityText, stateText, countryText };
    } else {
      return false;
    }
  } catch (err) {
    console.error(err);
  }
};

export const getLatestDateAmongTwo = (response1, response2) => {
  if (!response1?.updatedOn && response2?.updatedOn)
    return {
      updatedOn: response2.updatedOn,
      updatedBy: response2.updatedBy,
    };

  if (response1?.updatedOn && !response2?.updatedOn)
    return {
      updatedOn: response1.updatedOn,
      updatedBy: response1.updatedOn,
    };

  if (!response1?.updatedOn || !response2?.updatedOn)
    return {
      updatedOn: null,
      updatedBy: null,
    };

  const d1 = moment(response1.updatedOn);
  const d2 = moment(response2.updatedOn);

  if (d1.isAfter(d2))
    return {
      updatedOn: response1.updatedOn,
      updatedBy: response1.updatedBy,
    };
  return {
    updatedOn: response2.updatedOn,
    updatedBy: response2.updatedBy,
  };
};
